import React from 'react'
import { Link, NavLink } from 'react-router-dom'

function scrollToWorks() {
  if (location.pathname == "/") {
    console.log('scroll!');
    console.log(document.documentElement.scrollTop);
    setTimeout(function () {
      document.documentElement.scrollTop = 900;
      console.log(document.documentElement.scrollTop);
    }, 100);
  }
}

const Nav = () =>
  <nav>
    <section className="container">
      <aside className="page-title">
        <Link to="/">Sergi Miral</Link>
      </aside>
      <aside className="link-border">
        <NavLink className="flip-horizontal" to="/" exact onClick={scrollToWorks}>(ﾉ◕ヮ◕)ﾉ</NavLink>
        {/* <NavLink to="/feed">Live feed</NavLink> */}
        {/* <NavLink to="/about">About</NavLink> */}
        {/* <NavLink to="/contact">Contact</NavLink> */}
      </aside>
    </section>
  </nav>

export default Nav



// WEBPACK FOOTER //
// src/javascripts/components/Nav.js